import React, { Component } from 'react';

import '../css/SignIn.css';

class PendingLinkRequests extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPendingRequests = (roles, practices) => {

    const userRoles = roles || {};
    const practiceIDs = Object.keys(userRoles)

    const unApprovedRolesRows = practiceIDs.map((practiceID) => {
      const roleForPractice = userRoles[practiceID] || {};
      const practice = practices && practices[practiceID] ? practices[practiceID] : {};

      if (roleForPractice && practice && !roleForPractice.approved) {
        return <div className="flex-container flex-container-row flex-space-between"
                    style={{ margin: 10, alignItems: 'center' }}
                    key={practiceID}>
          <span>{ practice.name }</span>
          <input type='submit' value='Cancel' className='button-clear' onClick={ () => { this.cancelRequestAction(roleForPractice, this.props.token) }} />
        </div>
      }
    }).filter((role) => { return role });

    if (unApprovedRolesRows.length === 0) {
      return null;
    }

    return <div className="basic-container">
      <h4 style={{ marginBottom: 20 }}>Pending Requests</h4>
      { unApprovedRolesRows }
    </div>
  }

  render() {
    return this.renderPendingRequests(this.props.roles, this.props.practices);
  }

  cancelRequestAction = (role, token) => {
    const practiceID = role.practice_id;
    const userID = role.user_id;
    if (token&& practiceID && userID) {
      this.props.userActions.cancelPracticeJoinRequest(token, practiceID, userID);
    }
  }

}


export default PendingLinkRequests
